import BelvoModal from './BelvoModal';
export { BelvoModal };
export default BelvoModal;
